import { http } from '@shared/api';
import type { UUID } from '@shared/api';
import type { Carrier, CarrierCreate, CarrierUpdate } from './types';

export const carrierApi = {
  list: (activeOnly = false) =>
    http.get('logistics/carriers', { searchParams: { activeOnly: String(activeOnly) } }).json<Carrier[]>(),

  create: (body: CarrierCreate) => http.post('logistics/carriers', { json: body }).json<Carrier>(),

  update: (id: UUID, body: CarrierUpdate) =>
    http.put(`logistics/carriers/${id}`, { json: body }).json<Carrier>(),

  activate: (id: UUID) => http.post(`logistics/carriers/${id}/activate`).json<void>(),
  deactivate: (id: UUID) => http.post(`logistics/carriers/${id}/deactivate`).json<void>(),
};
